import React, { useEffect, useState } from "react";
import axios from "axios";

const AdminSectionManager = () => {
  const pages = [
    { title: "Home Page", id: "home_page" },
    { title: "About Us", id: "about_us" },
    { title: "Properties", id: "properties" },
    { title: "Contact", id: "contact" },
    { title: "Blog", id: "blog" },
    { title: "Services", id: "services" },
    { title: "Property Owners", id: "property_owners" },
  ];

  const accessToken = localStorage.getItem("authToken");

  const [sections, setSections] = useState({});
  const [selectedFiles, setSelectedFiles] = useState({});
  const [loading, setLoading] = useState({});

  const fetchSections = async () => {
    try {
      const response = await axios.get(
        "https://365luxuryhomes.com/api/sections"
      );

      if (Array.isArray(response.data)) {
        const sectionsData = response.data.reduce((acc, section) => {
          if (section.pageID) {
            acc[section.pageID] = section;
          }
          return acc;
        }, {});

        setSections(sectionsData);
      } else {
        console.error("Invalid response data format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching sections:", error);
    }
  };

  useEffect(() => {
    fetchSections();
  }, []);

  const handleFileChange = (pageId, file) => {
    setSelectedFiles((prev) => ({ ...prev, [pageId]: file }));
  };

  const handleAddOrUpdateSection = async (pageId) => {
    const file = selectedFiles[pageId];
    if (!file) return alert("Please select an image!");

    const maxSizeInBytes = 2 * 1024 * 1024; // 2MB
    if (file.size > maxSizeInBytes) {
      alert("File size exceeds 2MB. Please upload a smaller image.");
      return;
    }

    setLoading((prev) => ({ ...prev, [pageId]: true }));

    const formData = new FormData();
    formData.append("image", file);
    formData.append("pageId", pageId);

    try {
      if (sections[pageId]) {
        await axios.put(
          `https://365luxuryhomes.com/api/sections/${sections[pageId].pageID}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        alert("Section updated successfully!");
      } else {
        await axios.post("https://365luxuryhomes.com/api/sections", formData, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        alert("Section added successfully!");
      }
      fetchSections();
    } catch (error) {
      console.error("Error adding/updating section:", error);
    } finally {
      setLoading((prev) => ({ ...prev, [pageId]: false }));
      setSelectedFiles((prev) => ({ ...prev, [pageId]: null }));
    }
  };

  const handleDeleteSection = async (pageId) => {
    if (window.confirm("Are you sure you want to delete this section?")) {
      setLoading((prev) => ({ ...prev, [pageId]: true }));
      try {
        await axios.delete(
          `https://365luxuryhomes.com/api/sections/${sections[pageId]._id}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        alert("Section deleted successfully!");
        fetchSections();
      } catch (error) {
        console.error("Error deleting section:", error);
      } finally {
        setLoading((prev) => ({ ...prev, [pageId]: false }));
      }
    }
  };

  return (
    <div className="admin-page">
      <h1 className="admin-page-title">Manage Sections</h1>
      <p className="admin-page-desc">Upload hero images for each page section.</p>

      <div className="grid grid-cols-1 gap-4">
        {pages.map((page) => {
          const section = sections[page.id];
          return (
            <div key={page.id} className="admin-card">
              <h2 className="admin-card-title">{page.title}</h2>

              <div className="relative rounded-admin overflow-hidden bg-base-200">
                {section?.imageUrl || selectedFiles[page.id] ? (
                  <img
                    src={
                      selectedFiles[page.id]
                        ? URL.createObjectURL(selectedFiles[page.id])
                        : section?.imageUrl
                    }
                    alt={page.title}
                    className="w-full h-56 object-cover"
                  />
                ) : (
                  <div className="w-full h-56 flex items-center justify-center text-base-content/50 text-sm">
                    No image uploaded (Max 2 MB)
                  </div>
                )}
                {loading[page.id] && (
                  <div className="absolute inset-0 bg-base-100/80 flex items-center justify-center rounded-admin">
                    <span className="loading loading-spinner loading-md text-primary"></span>
                  </div>
                )}
              </div>

              <div className="mt-4">
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleFileChange(page.id, e.target.files[0])}
                  className="admin-input"
                />
              </div>

              <div className="mt-4 flex gap-3">
                <button
                  type="button"
                  onClick={() => handleAddOrUpdateSection(page.id)}
                  className="btn btn-primary rounded-admin"
                >
                  Save
                </button>
                {section && (
                  <button
                    type="button"
                    onClick={() => handleDeleteSection(page.id)}
                    className="btn btn-error rounded-admin"
                  >
                    Delete
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdminSectionManager;
